import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers}) => {
    const apiCalls = {
        inserirContrato(listaContratos){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/ContratoAcoes',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(listaContratos),
            });
        },
        cadastrarContratoProduto(contrato){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/CadastroProdutoContrato',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(contrato),
            });
        },
        removerProdutoContrato(contrato){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/RemoverProdutoContrato',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(contrato),
            });
        },
        atualizarContrato(contrato){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/EditarContrato',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(contrato),
            });
        },
        downloadPlanilha(tipoPerfilTribunal){            
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/DownloadPlanilhaModelo',
                responseType: 'arraybuffer',
                headers: headers,
                data: {
                    'tipoPerfilTribunal': tipoPerfilTribunal
                    }
            });
        },
        carregarPlanilha(tipoPerfilTribunal, arquivoInicial, idPerfilTribunal, idUsuarioPortal){
            const formData = new FormData();
            formData.append('tipoPerfilTribunal', tipoPerfilTribunal);
            formData.append('idPerfilTribunal', idPerfilTribunal);
            formData.append('idUsuarioPortal', idUsuarioPortal);
            formData.append('arquivoInicial', arquivoInicial);
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/CarregarPlanilha',
                responseType: 'json',
                headers: {'Content-Type':'multipart/form-data'},
                data: formData
            });
        },
        recuperarContratoExibicao(idUsuario, idPerfilTribunal, idCliente){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/RecuperarContratoExibicao',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({
                    'idUsuario': idUsuario,
                    'idPerfilTribunal': idPerfilTribunal,
                    'idCliente': idCliente
                    })
            });
        },
        buscarContratoId(id){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/BuscarContratoId',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({'Id': id})
            });
        },
        controleContratos(filtros){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/ControleContratos',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filtros)
            });
        },
        recuperarContratoAprovacaoGestorExibicao(idUsuario, idPerfilTribunal, idCliente){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/RecuperarContratoAprovacaoGestorExibicao',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({
                    'idUsuario': idUsuario,
                    'idPerfilTribunal': idPerfilTribunal,
                    'idCliente': idCliente
                    })
            });
        },
        aprovacaoGestor(listaIdContrato, aprovado, idUsuario){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/AprovacaoGestor',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({
                    'listaIdContrato': listaIdContrato,
                    'aprovado': aprovado,
                    'idUsuario': idUsuario
                    })
            });            
        },
        quantidadeAprovacaoGestor(idUsuario, idPerfilTribunal, idCliente){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/QuantidadeAprovacaoGestor',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({
                    'idUsuario': idUsuario,
                    'idPerfilTribunal': idPerfilTribunal,
                    'idCliente': idCliente
                    })
            });
        },
        rejeitarCredencial(idContrato, idUsuario){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/RejeitarCredencial',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({
                    'idContrato': idContrato,
                    'idUsuario': idUsuario
                })
            });
        },
        reprocessarCredencial(idContrato, idUsuario){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/ReprocessarCredencial',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({
                    'idContrato': idContrato,
                    'idUsuario': idUsuario
                })
            });
        },
        historicoContrato(idPerfilTribunal, idProduto){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/HistoricoContrato',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({
                    'idPerfilTribunal': idPerfilTribunal,
                    'idProduto': idProduto
                })
            });
        },
        setErroLoginCredencial(idContrato, idUsuario){
            return instance({
                method: 'post',
                baseURL,
                url: 'Contrato/SetErroLoginCredencial',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({
                    'idContrato': idContrato,
                    'idUsuario': idUsuario
                })
            });
        },
    }
    return apiCalls;
}